// eslint-disable-next-line no-unused-vars
import RedirectMiddleware from '@/middleware/RedirectMiddleware';
import routesMap from '@/routes/routeMap';

const country = process.env.VUE_APP_COUNTRY_ISO;

export default [
    {
        path: routesMap[country].home,
        name: 'home',
        beforeEnter: (too, from, next) => { RedirectMiddleware(too, from, next); },
        components: {
            default: () => import(/* webpackChunkName: "home" */ '@/views/DynamicHome.vue'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 1,
        },
    },
    {
        path: '/the-flowers',
        name: 'flowers',
        components: {
            default: () => import(/* webpackChunkName: "landing" */ '@/views/content/LandingPage.vue'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 2,
        },
    },
    {
        path: '/the-delivery',
        name: 'delivery',
        components: {
            default: () => import(/* webpackChunkName: "landing" */ '@/views/content/LandingPage.vue'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 3,
        },
    },
    {
        path: '/the-arranging',
        name: 'arranging',
        components: {
            default: () => import(/* webpackChunkName: "landing" */ '@/views/content/LandingPage.vue'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 4,
        },
    },
    {
        path: 'about.freddiesflowers.de/nachhaltigkeit/',
        name: 'sustainability',
        beforeEnter() { window.open('https://about.freddiesflowers.de/nachhaltigkeit/', '_blank'); },
    },
];
